export default __webpack_public_path__ + "static/media/2023_März_Spirale.bda9367f.webp";